class AutocompleteIndexedDB {
  constructor (dbName, version = 1) {
    this.DBOpenRequest = window.indexedDB.open(dbName, version)
    this.db = ''
    this.dbName = dbName
    this.dbversion = version
    this._init()
  }

  _init () {
    this._successHandle()
    this._errorHandle()
    this._upgradeneededHandle()
  }

  _successHandle () {
    this.DBOpenRequest.onsuccess = (event) => {
      // 存储数据结果
      this.db = this.DBOpenRequest.result
    }
  }

  _errorHandle () {
    this.DBOpenRequest.onerror = (event) => {
      console.error('数据库打开失败')
    }
  }

  _upgradeneededHandle (event) {
    this.DBOpenRequest.onupgradeneeded = (event) => {
      this.db = event.target.result
      this.db.onerror = function (event) {
        console.error('数据库打开失败')
      }
      let objectStore = this.db.createObjectStore(this.dbName, {
        keyPath: 'id',
        autoIncrement: true,
      })
      objectStore.createIndex('id', 'id', {
        unique: true,
      })
      objectStore.createIndex('componentKey', 'componentKey', {
        unique: true,
      })
      objectStore.createIndex('keyWord', 'keyWord')
    }
  }

  add (newItem) {
    // 为何要在添加时才能打开仓库
    let objectStore = this.db.transaction([this.dbName], 'readwrite').objectStore(this.dbName)
    let objectStoreRequest = objectStore.add(newItem)
    return new Promise((resolve, reject) => {
      objectStoreRequest.onsuccess = (event) => {
        resolve(newItem)
      }
      objectStoreRequest.onerror = event => {
        resolve('')
      }
    })
  }

  edit (data) {
    let objectStore = this.db.transaction([this.dbName], 'readwrite').objectStore(this.dbName)
    let objectStoreRequest = objectStore.get(data.id)
    return new Promise((resolve, reject) => {
      objectStoreRequest.onsuccess = event => {
        let myRecord = objectStoreRequest.result
        Reflect.ownKeys(myRecord).forEach(key => {
          myRecord[key] = data[key]
        })
        objectStore.put(myRecord)
        resolve(myRecord)
      }
      objectStoreRequest.onerror = event => {
        resolve('')
      }
    })
  }

  get (key) {
    let objectStore = this.db.transaction(this.dbName).objectStore(this.dbName)
    let index = objectStore.index('componentKey')
    return new Promise((resolve, reject) => {
      index.get(key).onsuccess = (event) => {
        resolve(event.target.result)
      }
      index.get(key).onerror = (event) => {
        resolve('')
      }
    })
  }
}

export default new AutocompleteIndexedDB('autocomplete')
